import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { BoreholeCardModal } from '@/components/card/BoreholeCardModal';

// Edytor „karty otworu" jako osobna strona (trasa /otwory/:id/karta). Osadza edytor w trybie asPage.
// backLabel przekazywany przez router state (np. z listy „Karty otworów" albo z ujęcia); domyślnie „Powrót".
export function BoreholeCardEditor() {
  const { id } = useParams();
  const nav = useNavigate();
  const loc = useLocation();
  const backLabel = (loc.state as { backLabel?: string } | null)?.backLabel ?? 'Powrót';
  const boreholeId = Number(id);
  if (!Number.isFinite(boreholeId)) {
    return <div style={{ padding: 16 }}>Nieprawidłowy identyfikator otworu.</div>;
  }
  return (
    <div style={{ padding: 12 }}>
      <BoreholeCardModal open asPage boreholeId={boreholeId} backLabel={backLabel} onClose={() => nav(-1)} onSaved={() => { /* noop */ }} />
    </div>
  );
}
